import { Component, OnInit } from '@angular/core';
import { ProfileService } from '../profile/profile.service';
import { Profile, ApiAccess } from '../models/profile.model';
import { NotificationBuilder } from '../shared/notificationBuilder';
import { AuthenticationService } from "../authentication/authentication.service";
import { HelperService } from '../services/helper.service';

declare var swal: any
declare var $: any

@Component({
  selector: 'app-compredoe',
  templateUrl: './compredoe.component.html',
  styleUrls: ['./compredoe.component.css']
})
export class CompreDoeComponent implements OnInit {
  profile: Profile
  apiAccess: ApiAccess
  script: string = ""
  public isAdmin: boolean
  loading: boolean = false
  loadingMessage: string = "Conectando com a API. Isso pode demorar um pouco!"
  constructor(public authenticationService: AuthenticationService, private profileService: ProfileService, private helperService: HelperService, private notificationBuilder: NotificationBuilder) {
  }

  ngOnInit() {
    this.isAdmin = localStorage.getItem("admin-token") != null
    this.profileService.getCurrentUserInfo().subscribe(data => {
      debugger
      this.profile = data
      console.log(data)
      this.profileService.getApiAccess().subscribe(model => {
        if (model.success) {
          this.apiAccess = model.data
        }

      })
      this.script = this.helperService.getSeloCompreDoeScript(this.profile)
    })
  }

  copyToClipboard() {
    let script = document.getElementById("scriptHelper") as HTMLInputElement;
    script.value = "";
    script.value = this.script;
    script.select();

    document.execCommand("Copy");
    this.notificationBuilder.showNotification(
      "success",
      1000,
      "O HTML do selo foi copiado."
    );
  }

  showTestLive() {
    //para corrigir o erro -> https://stackoverflow.com/questions/53298478/has-been-blocked-by-cors-policy-response-to-preflight-request-doesn-t-pass-acce
    debugger
    this.profileService.goToJsFiddle(this.script, 'Selo da ' + this.profile.storeName + ' no Movimento CompreDoe', 'este é seu selo')
      .subscribe(data => {
        debugger
        console.log(data);
      })
  }

  sendToDeveloper() {

    swal({
      title: 'Enviar por E-mail',
      text: 'Envie aqui para quem vai adicionar o script. Leva em média 5 minutos!',
      html:
        '<input id="name-dev" class="swal2-input" placeholder="Nome">' +
        '<input id="email-dev" type="email" placeholder="E-mail" class="swal2-input">',
      focusConfirm: false
    })
      .then((ok) => {
        if (ok) {
          let name = $("#name-dev").val()
          let email = $("#email-dev").val()
          this.helperService.sendEmailScriptToDeveloper(email, name, this.profile.storeSeoName)
          swal({
            type: 'success',
            title: 'Script Enviado =)',
            text: 'Enviamos o script por e-mail para ' + name + '. De qualquer maneira, avisa ele(a) também. Leva menos de 5 para add o Polen ;)',
          })
        }
      })

  }
}





